import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { useIntl } from 'react-intl';
import { useLocation } from '@gatsbyjs/reach-router';
import {
  Banner, Button,
} from '@printdeal/ui-library';
import { getLanguageFromLocale } from '../../../helpers/translations';
import ContentfulCardImage from '../../ContentfulCardImage';
import { dispatchDataLayerEventOnCreateQuoteRequest } from '../../../helpers/dataLayerHelpers/quoteDataLayerHelper';
import { IProductQuote } from '../../../types/product/productDetailPage';

interface Props {
  productQuote: IProductQuote;
}

const PPAGBanner = ({ productQuote }: Props) => {
  const intl = useIntl();
  const location = useLocation();
  const { locale } = intl;
  const localPath = getLanguageFromLocale(locale);

  if (!productQuote) return null;

  const {
    title,
    content,
    buttonText,
    buttonUrl,
    quotePdpImage,
  } = productQuote;

  const quoteRequestUrl = buttonUrl
    ? `/${localPath}/${buttonUrl.replace(/^\/|\/$/g, '')}`
    : '/account/quoting/request/new';

  const defaultTitle = intl.formatMessage({
    id: 'ppagBanner.defaultTitle',
    defaultMessage: 'Need help choosing the right product?',
  });

  const defaultContent = intl.formatMessage({
    id: 'ppagBanner.defaultContent',
    defaultMessage: 'Our experts are here to assist you with a custom quote.',
  });

  const defaultButtonText = intl.formatMessage({
    id: 'ppagBanner.buttonText',
    defaultMessage: 'Request a quote',
  });

  const image = quotePdpImage?.title !== 'Default Quote Request Image' ? quotePdpImage : undefined;

  return (
    <Banner
      variant="dim-vertical"
      title={title || defaultTitle}
      className="sm:pd-ml-0 lg:pd-ml-4"
      image={(
        <div className="pd-absolute pd-bottom-0 pd-right-10 pd-hidden pd-w-32 lg:pd-block">
          <ContentfulCardImage src={image?.url || ''} alt={image?.title || ''} />
        </div>
      )}
      button={(
        <Button
          as={GatsbyLink}
          to={quoteRequestUrl}
          state={{ redirectUrl: buttonUrl }}
          variant="white"
          iconBefore="arrow-right"
          className="lg:pd-mb-8"
          onClick={() =>
            dispatchDataLayerEventOnCreateQuoteRequest(location.pathname)}
        >
          {buttonText || defaultButtonText}
        </Button>

      )}
    >
      <p className="pd-text-lg pd-font-normal">{content?.content || defaultContent}</p>
    </Banner>
  );
};

export default PPAGBanner;
